import { render, staticRenderFns } from "./PerformanceProductDetail.vue?vue&type=template&id=3e4a8150&scoped=true&"
import script from "./PerformanceProductDetail.vue?vue&type=script&lang=js&"
export * from "./PerformanceProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4a8150",
  null
  
)

export default component.exports